(() => {
  const initializeHero = (root) => {
    if (!root || root.dataset.dpHeroInitialized === 'true') return;
    root.dataset.dpHeroInitialized = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          window.requestAnimationFrame(() => entry.target.classList.add('is-visible'));
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -4% 0px'
      }
    );

    observer.observe(root);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-dp-hero-root]').forEach(initializeHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
